import React from 'react';
import { Link } from 'react-router-dom';
import './PaginasMP.css';

/**
 * Layout compartido para respuestas de pago (MercadoPago u otros).
 * @param {'success'|'failure'|'pending'} variant
 */
export default function PaymentResultShell({
  variant,
  title,
  subtitle,
  children,
  primaryLabel,
  primaryTo = '/',
  secondaryLabel,
  secondaryTo = '/productos',
  showSecondary = true,
}) {
  return (
    <main
      className={`mp-result mp-result--${variant}`}
      role="status"
      aria-live="polite"
    >
      <div className="mp-result__inner">
        <div className="mp-result__card">
          <div className={`mp-result__icon-wrap mp-result__icon-wrap--${variant}`} aria-hidden>
            {variant === 'success' && <IconSuccess />}
            {variant === 'failure' && <IconFailure />}
            {variant === 'pending' && <IconPending />}
          </div>
          <h1 className="mp-result__title">{title}</h1>
          {subtitle && <p className="mp-result__subtitle">{subtitle}</p>}
          {children}
          <div className="mp-result__actions">
            <Link to={primaryTo} className="mp-result__btn mp-result__btn--primary">
              {primaryLabel}
            </Link>
            {showSecondary && secondaryLabel && (
              <Link to={secondaryTo} className="mp-result__btn mp-result__btn--secondary">
                {secondaryLabel}
              </Link>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}

function IconSuccess() {
  return (
    <svg className="mp-result__icon-svg" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="28" stroke="currentColor" strokeWidth="3" fill="none" opacity="0.35" />
      <path
        d="M20 32l9 9 16-18"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconFailure() {
  return (
    <svg className="mp-result__icon-svg" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="28" stroke="currentColor" strokeWidth="3" fill="none" opacity="0.35" />
      <path d="M24 24l16 16M40 24L24 40" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" />
    </svg>
  );
}

function IconPending() {
  return (
    <svg className="mp-result__icon-svg" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="28" stroke="currentColor" strokeWidth="3" fill="none" opacity="0.35" />
      <path
        d="M32 20v14l10 6"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
